export default __webpack_public_path__ + "assets/images/g-item-bg-08e82471.jpg";